<template>
  <v-card :disabled="loading">
    <v-form @submit.prevent="handleSubmit">
      <v-card-title>
        {{ title }}
      </v-card-title>
      <v-card-subtitle>
        {{ subtitle }}
      </v-card-subtitle>
      <v-card-text>
        <v-alert v-if="errorMessage.length > 0" type="error" text>{{
          errorMessage
        }}</v-alert>
        <v-text-field
          v-model="form.nome"
          label="Nome"
          :readonly="readonly"
          :error-messages="errors.nome"
          outlined
        ></v-text-field>
        <v-text-field
          v-model="form.telefone"
          label="Telefone"
          v-mask="'(##) ####?#-####'"
          placeholder="(00) 00000-0000"
          type="tel"
          :readonly="readonly"
          :error-messages="errors.telefone"
          outlined
        ></v-text-field>
        <v-textarea
          v-model="form.observacoes"
          label="Observações"
          :readonly="readonly"
          :error-messages="errors.observacoes"
          outlined
        >
        </v-textarea>
      </v-card-text>

      <v-card-actions v-if="!readonly">
        <v-spacer></v-spacer>
        <v-btn type="submit" color="primary" elevation="0" :loading="loading"
          >Salvar</v-btn
        >
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import api from "../services/locacoes";
import alertsMixin from "../mixins/alerts";

export default {
  mixins: [alertsMixin],

  components: {},

  props: {
    title: {
      type: String,
      default: "Comprador"
    },
    subtitle: {
      type: String,
      default:
        "Preencha quando um indivíduo comprar utilizando o crediário de outro"
    },
    readonly: Boolean,
    valorInicial: Object,
    locacaoId: Number
  },

  data() {
    return {
      form: {},
      errors: {},
      errorMessage: "",
      loading: false
    };
  },

  methods: {
    async handleSubmit() {
      this.loading = true;
      this.errors = {};
      this.errorMessage = "";

      try {
        const response = await api.locacoes.atualizarComprador(
          this.locacaoId,
          this.form
        );

        this.$emit("atualizado", response);
        this.success("Comprador atualizado");
      } catch (error) {
        if (error.response.status === 422) {
          this.errors = error.response.data.errors;
          this.errorMessage = error.response.data.message;
          return;
        }

        this.error("Erro inesperado, não foi possível atualizar o comprador");
      } finally {
        this.loading = false;
      }
    }
  },

  computed: {},

  created() {
    this.form = this.valorInicial ? this.valorInicial : {};
    this.errors = {};
  }
};
</script>
